export default "__VITE_ASSET__CD9Vdob9__"